import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Text } from 'components/core/Typography';
import { Badge } from 'components/molecules/Badge';
import { TooltipBanner } from 'components/molecules';

import './UnitDescription.scss';

export default function UnitDescription({
	className,
	unitSize,
	unitType,
	amenitiesText,
	promotion,
	vehicleAccommodation,
	tierName,
	tierDescription,
	isScarce,
	unitQuantity,
}) {
	const showAmenitiesText = amenitiesText || tierDescription;

	// Check if promotion is valid (non-empty string or truthy value)
	const hasValidPromotion = promotion && (
		typeof promotion === 'string' ? promotion.trim().length > 0 : !!promotion
	);

	// Prepare promotion content for tooltip
	const getPromotionContent = () => {
		if (!hasValidPromotion) {
			return null;
		}

		return (
			<>
				<Text size="tiny" weight="bold" style={{ textTransform: 'uppercase' }} last>
					PROMO:
				</Text>
				<Text size="tiny" color="black">
					{promotion}
				</Text>
			</>
		);
	};

	const promotionContent = getPromotionContent();
	const badge = (
		<Badge
			badgeColor="green"
			className="unit-promo-badge"
			badgeText="Deal"
			textSize="tiny"
		/>
	);

	return (
		<div className={classnames('atomic-unit-description', className)}>
			<Text className="unit-size-label-description" size="small" last>
				{unitSize}
				{!!tierName && <span> - {tierName}</span>}
			</Text>
			{!!vehicleAccommodation && (
				<Text size="tiny" className="vehicle-accommodation">
					{vehicleAccommodation}
				</Text>
			)}
			{showAmenitiesText && (
				<Text className="unit-amenities" last={!hasValidPromotion}>
					{amenitiesText && tierDescription ? (
						<>
							{`${amenitiesText}, `}
							<span>{tierDescription}</span>
						</>
					) : (
						<span>{amenitiesText || tierDescription}</span>
					)}
				</Text>
			)}
			{hasValidPromotion && (
				promotionContent ? (
					<TooltipBanner
						content={promotionContent}
						className="promo-tooltip"
						triggerAlignment="center"
					>
						{badge}
					</TooltipBanner>
				) : (
					badge
				)
			)}
			{isScarce && (
				<Text color="orange" size="tiny" weight="bold" last>
					{unitQuantity} Left
				</Text>
			)}
		</div>
	);
}

UnitDescription.propTypes = {
	className: PropTypes.string,
	unitSize: PropTypes.string.isRequired,
	unitType: PropTypes.string.isRequired,
	promotion: PropTypes.node,
	amenitiesText: PropTypes.string,
	vehicleAccommodation: PropTypes.string,
	tierName: PropTypes.string,
	tierDescription: PropTypes.string,
	isScarce: PropTypes.bool,
	unitQuantity: PropTypes.number,
	giftCardOffer: PropTypes.object,
};

